export default "__VITE_ASSET__Z0RkN7J2__"